import { useEffect } from 'react'
import { SITE } from '../constants'

type PageMeta = {
    title: string
    description: string
    path: string
}

function setMeta(attr: 'name' | 'property', key: string, content: string) {
    let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
    if (!el) {
        el = document.createElement('meta')
        el.setAttribute(attr, key)
        document.head.appendChild(el)
    }
    el.setAttribute('content', content)
}

/**
 * Sets per-route title, description, canonical and OpenGraph/Twitter tags.
 * Defaults for crawlers that don't run JS live in public/index.html.
 */
export default function usePageMeta({ title, description, path }: PageMeta) {
    useEffect(() => {
        const fullTitle = title.includes(SITE.name) ? title : `${title} | ${SITE.name}`
        const url = `${SITE.url}${path}`
        document.title = fullTitle
        setMeta('name', 'description', description)
        setMeta('property', 'og:title', fullTitle)
        setMeta('property', 'og:description', description)
        setMeta('property', 'og:url', url)
        setMeta('name', 'twitter:title', fullTitle)
        setMeta('name', 'twitter:description', description)

        let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
        if (!canonical) {
            canonical = document.createElement('link')
            canonical.rel = 'canonical'
            document.head.appendChild(canonical)
        }
        canonical.href = url
    }, [title, description, path])
}
